<template>
	<section>
		<b-row :class="[specialClass]">
			<svg class="d-none d-md-block" v-if="top" style="height: 50px; width: 100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none"><polygon fill="#F7F7F7" points="0,100 100,0 100,100"/></svg>
			<b-col class="bg-grey">
				<slot></slot>
			</b-col>
			<svg class="d-none d-md-block" v-if="bottom" style="height: 50px; width: 100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none"><polygon fill="#F7F7F7" points="0,0 100,0 100,100"/></svg>
		</b-row>
	</section>
</template>

<script>
  export default {
	name: 'v-section-grey',
	props: {
		specialClass: String,
		top: {default: true},
		bottom: {default: true}
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
